module.exports = __webpack_public_path__ + "img/x7.8bf0569d.jpg";